/* Vila Pure - Domaca proizvodnja lander: motion (Ken Burns, hero stagger,
   scroll reveal, brojaci). Port DC _setupMotion logike, bez zavisnosti. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  [].slice.call(document.querySelectorAll('.vpd-root')).forEach(function (root) {
    var photo = root.querySelector('[data-hero-photo]');
    if (photo && !reduce && !photo.dataset.animated) { photo.dataset.animated = '1'; photo.style.animation = 'vpKenBurns 9s cubic-bezier(.2,.6,.2,1) both'; }
    var hero = root.querySelector('[data-hero-stagger]');
    if (hero && !reduce && !hero.dataset.animated) {
      hero.dataset.animated = '1';
      [].slice.call(hero.children).forEach(function (el, i) { el.style.animation = 'vpHeroIn .8s cubic-bezier(.2,.7,.2,1) ' + (120 + i * 110) + 'ms both'; });
    }
    var sections = [].slice.call(root.querySelectorAll('section')).filter(function (s) { return !s.hasAttribute('data-vpd-hero'); });
    var targets = [];
    sections.forEach(function (sec) {
      var panel = sec.firstElementChild; if (!panel) return;
      [].slice.call(panel.children).forEach(function (k) {
        var isGrid = /grid|flex/.test(getComputedStyle(k).display) && k.children.length >= 3 && k.children.length <= 8 && !k.querySelector('video');
        if (isGrid) [].slice.call(k.children).forEach(function (c, i) { c.setAttribute('data-reveal', ''); c.style.setProperty('--rd', (i * 90) + 'ms'); targets.push(c); });
        else { k.setAttribute('data-reveal', ''); targets.push(k); }
      });
    });
    var counters = [].slice.call(root.querySelectorAll('[data-count]'));
    var runCount = function (el) {
      if (el.dataset.counted) return; el.dataset.counted = '1';
      var end = parseInt(el.dataset.count, 10); var dur = 1400; var t0 = performance.now();
      var step = function (now) { var p = Math.min(1, (now - t0) / dur); var e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(end * e); if (p < 1) requestAnimationFrame(step); };
      if (reduce) { el.textContent = end; return; }
      requestAnimationFrame(step);
    };
    if ('IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); cio.unobserve(e.target); } }); }, { threshold: 0.4 });
      counters.forEach(function (c) { cio.observe(c); });
    } else counters.forEach(runCount);
    if (reduce || !('IntersectionObserver' in window)) { targets.forEach(function (t) { t.setAttribute('data-reveal', 'in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.setAttribute('data-reveal', 'in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    targets.forEach(function (t) { var r = t.getBoundingClientRect(); if (r.top < window.innerHeight * 0.9) t.setAttribute('data-reveal', 'in'); else io.observe(t); });
  });
})();
